/* BYB paid landing page (sections/byb-lp.liquid).
   Offer math comes from the section config, which comes from Theme settings, so this page
   and /collections/build-your-bundle always price the same bundle the same way.
   Cart contract: /cart/add.js then [data-cart-open] (snippets/cart-drawer.liquid). */
(function () {
  var root = document.querySelector('[data-bl]');
  if (!root || root.__blBound) return;
  root.__blBound = true;

  var CFG, PRODUCTS;
  try {
    CFG = JSON.parse(root.querySelector('[data-bl-config]').textContent);
    PRODUCTS = JSON.parse(root.querySelector('[data-bl-products]').textContent);
  } catch (e) { return; }

  var q = function (s, sc) { return (sc || root).querySelector(s); };
  var qa = function (s, sc) { return Array.prototype.slice.call((sc || root).querySelectorAll(s)); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  function fmt(c) {
    if (window.Onside && Onside.formatMoney) return Onside.formatMoney(c, window.onsideMoneyFormat);
    return '$' + (Math.round(c) / 100).toFixed(2);
  }

  /* ---------- offer math (single source of truth) ---------- */
  var LADDER = String(CFG.ladder || '').split(',').map(function (s) {
    var kv = s.split(':');
    return { at: parseInt(kv[0], 10), pct: parseInt(kv[1], 10) };
  }).filter(function (r) { return r.at > 0 && r.pct > 0; }).sort(function (a, b) { return a.at - b.at; });
  var ALL = (function () {
    var kv = String(CFG.allIn || '').split(':');
    return { at: parseInt(kv[0], 10) || 0, pct: parseInt(kv[1], 10) || 0 };
  })();
  var PROTECT_AT = parseInt(CFG.protectAt, 10) || 0;
  var CREDIT_MIN = parseInt(CFG.creditMin, 10) || 0;
  var THRESHOLD = parseInt(CFG.threshold, 10) || 0;
  var DAYS = parseInt(CFG.days, 10) || 30;

  function rateFor(n) {
    var r = 0;
    LADDER.forEach(function (t) { if (n >= t.at) r = t.pct; });
    if (ALL.at && n >= ALL.at) r = ALL.pct;
    return r;
  }

  /* ---------- stock-driven line-ups ---------- */
  var ORDER = String(CFG.packOrder || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  var BY_HANDLE = {};
  PRODUCTS.forEach(function (p) { BY_HANDLE[p.handle] = p; });

  function inStockVariants(p) { return (p.variants || []).filter(function (v) { return v.available; }); }
  function sellable(p) { return !!p && p.available && inStockVariants(p).length > 0; }

  var AVAIL = ORDER.map(function (h) { return BY_HANDLE[h]; }).filter(sellable);
  PRODUCTS.forEach(function (p) { if (sellable(p) && AVAIL.indexOf(p) === -1) AVAIL.push(p); });

  var PACKS = {
    basics: AVAIL.slice(0, Math.min(parseInt(CFG.basicsCount, 10) || 3, AVAIL.length)),
    routine: AVAIL.slice(0, Math.min(parseInt(CFG.routineCount, 10) || 5, AVAIL.length)),
    all: AVAIL.slice(0)
  };

  /* ---------- naming ---------- */
  var CHIP_MAP = [
    ['deodorant', 'Deo'], ['body-wash', 'Wash'], ['shampoo', 'Hair'], ['body-cream', 'Cream'],
    ['face-cleanser', 'Cleanser'], ['moisturizer', 'Moist'], ['toner', 'Toner'],
    ['eye-gel', 'Eye'], ['exfoliation', 'Scrub'], ['body-spray', 'Spray']
  ];
  var NAME_MAP = [
    ['deodorant', 'Deodorant'], ['body-wash', 'Body Wash'], ['shampoo', '2-in-1 Shampoo'],
    ['body-cream', 'Body Cream'], ['face-cleanser', 'Face Cleanser'], ['moisturizer', 'Moisturizer'],
    ['toner', 'Toner'], ['eye-gel', 'Eye Gel'], ['exfoliation', 'Face Scrub'], ['body-spray', 'Body Spray']
  ];
  function shortTitle(p) {
    var h = String(p.handle || '').toLowerCase();
    for (var i = 0; i < NAME_MAP.length; i++) if (h.indexOf(NAME_MAP[i][0]) > -1) return NAME_MAP[i][1];
    return p.short || p.title;
  }
  function chipName(p) {
    var h = String(p.handle || '').toLowerCase();
    for (var i = 0; i < CHIP_MAP.length; i++) if (h.indexOf(CHIP_MAP[i][0]) > -1) return CHIP_MAP[i][1];
    return String(p.short || p.title || '').split(' ')[0];
  }
  function shortScent(t) {
    var s = String(t || '').trim();
    if (!s || /default/i.test(s)) return '';
    if (/fragrance[\s-]*free|unscented/i.test(s)) return 'FF';
    if (/eucalyptus/i.test(s)) return 'Euc Mint';
    if (/santal/i.test(s)) return 'Santal';
    if (/green tea/i.test(s)) return 'Green Tea';
    if (/tea tree/i.test(s)) return 'Tea Tree';
    if (/hinoki/i.test(s)) return 'Hinoki';
    return s.split(' ').slice(0, 2).join(' ');
  }

  /* ---------- state ---------- */
  var state = {
    pack: 'routine',
    items: [],          // handles, in pack order
    sel: {},            // handle -> variant id
    hero: 0,            // 0 = the whole pack, 1..n = one product
    scentsOpen: false,
    swapOpen: false,
    busy: false
  };

  function defaultVariant(p) {
    var vs = inStockVariants(p);
    return vs[0] || (p.variants || [])[0];
  }
  function variantOf(p) {
    var id = state.sel[p.handle];
    var found = (p.variants || []).filter(function (v) { return v.id === id && v.available; })[0];
    return found || defaultVariant(p);
  }
  function chosen() {
    return state.items.map(function (h) { return BY_HANDLE[h]; }).filter(sellable);
  }
  function setPack(key) {
    state.pack = key;
    state.items = (PACKS[key] || []).map(function (p) { return p.handle; });
    state.hero = 0;
    render();
  }

  // Shopify applies the automatic discount per line and floors each line's discount to the cent,
  // so the page sums per-line prices the same way and matches the cart exactly.
  function lineSum(ps, pct) {
    var sum = 0;
    ps.forEach(function (p) { var pr = variantOf(p).price; sum += pr - Math.floor(pr * pct / 100); });
    return sum;
  }
  function totals() {
    var list = 0, ps = chosen();
    ps.forEach(function (p) { list += variantOf(p).price; });
    var n = ps.length;
    var pct = rateFor(n);
    var price = lineSum(ps, pct);
    return {
      n: n, pct: pct, list: list, price: price, save: list - price,
      allIn: !!(ALL.at && n >= ALL.at),
      freeShip: price >= THRESHOLD,
      protect: PROTECT_AT > 0 && n >= PROTECT_AT,
      credit: CREDIT_MIN > 0 && n >= CREDIT_MIN,
      perDay: DAYS > 0 ? Math.round(price / DAYS) : 0
    };
  }
  function nextRung(n) {
    var rungs = LADDER.slice();
    if (ALL.at) rungs.push({ at: ALL.at, pct: ALL.pct });
    for (var i = 0; i < rungs.length; i++) if (n < rungs[i].at) return rungs[i];
    return null;
  }

  /* ---------- render: hero ---------- */
  var HEIGHTS = [1, .88, .8, .74, .7, .66, .63, .6, .58, .56];
  function renderHero(t) {
    var ps = chosen(), stack = q('[data-bl-stack]'), thumbs = q('[data-bl-thumbs]'), cap = q('[data-bl-cap]');
    if (!stack) return;
    var one = state.hero > 0 ? ps[state.hero - 1] : null;
    var lineup = !one && CFG.packImages && CFG.packImages[state.pack];
    stack.classList.toggle('bl__stack--one', !!one);
    stack.classList.toggle('bl__stack--lineup', !!lineup);
    if (lineup) {
      stack.innerHTML = '<img class="bl__lineup" src="' + esc(lineup) + '" alt="' + esc(CFG.packNames[state.pack] || 'Your pack') + '">';
      renderThumbs(ps, thumbs);
      renderCap(t, cap);
      var badge0 = q('[data-bl-badge]');
      if (badge0) { badge0.textContent = t.pct ? t.pct + '% off' : ''; badge0.hidden = !t.pct; }
      return;
    }
    if (one) {
      stack.innerHTML = '<img src="' + esc(variantOf(one).image || one.image) + '" alt="' + esc(one.title) + '" style="width:72%;height:auto">';
    } else {
      var n = ps.length || 1;
      var wide = Math.min(46, (100 / n) * 1.8);            // each image wider than its 1/n slot …
      var over = n > 1 ? (n * wide - 100) / (n - 1) : 0;   // … and overlapped so the row still fits
      stack.innerHTML = ps.map(function (p, i) {
        return '<img src="' + esc(variantOf(p).image || p.image) + '" alt="" loading="' + (i < 2 ? 'eager' : 'lazy') +
          '" style="width:' + wide.toFixed(2) + '%;height:auto;' +
          'margin-left:' + (i ? (-over).toFixed(2) + '%' : '0') + ';z-index:' + (n - i) +
          ';transform:scale(' + (HEIGHTS[i] || .8).toFixed(2) + ');transform-origin:center bottom">';
      }).join('');
    }
    renderThumbs(ps, thumbs);
    var badge = q('[data-bl-badge]');
    if (badge) { badge.textContent = t.pct ? t.pct + '% off' : ''; badge.hidden = !t.pct; }
    renderCap(t, cap);
  }
  function renderThumbs(ps, thumbs) {
    if (!thumbs) return;
    thumbs.innerHTML = ps.map(function (p, i) {
      return '<button type="button" class="bl__thumb' + (state.hero === i + 1 ? ' is-on' : '') +
        '" data-bl-thumb="' + (i + 1) + '" aria-label="' + esc(p.title) + '">' +
        '<img src="' + esc(variantOf(p).image || p.image) + '" alt="" loading="lazy"></button>';
    }).join('');
  }
  function renderCap(t, cap) {
    if (!cap) return;
    cap.textContent = t.n
      ? t.n + '-product pack · ' + fmt(t.perDay) + ' a day for a month'
      : 'Pick a pack to see your price';
  }

  /* ---------- render: packs ---------- */
  function packMedia(ps, key) {
    var lineup = CFG.packImages && CFG.packImages[key];
    if (lineup) return '<span class="bl__pack-m"><img class="bl__pack-lineup" src="' + esc(lineup) + '" alt="" loading="lazy"></span>';
    var show = ps.slice(0, 4);
    var more = ps.length - show.length;
    var n = show.length || 1;
    var wide = Math.min(52, (100 / n) * 1.7), over = n > 1 ? (n * wide - 100) / (n - 1) : 0;
    return '<span class="bl__pack-m">' + show.map(function (p, i) {
      return '<img src="' + esc(variantOf(p).image || p.image) + '" alt="" loading="lazy" style="width:' + wide.toFixed(2) +
        '%;height:auto;margin-left:' + (i ? (-over).toFixed(2) + '%' : '0') + ';z-index:' + (n - i) + '">';
    }).join('') + (more > 0 ? '<span class="bl__pack-more">+' + more + '</span>' : '') + '</span>';
  }
  function packPrice(ps) {
    var list = 0;
    ps.forEach(function (p) { list += variantOf(p).price; });
    var pct = rateFor(ps.length);
    return { list: list, pct: pct, price: lineSum(ps, pct) };
  }
  function renderPacks() {
    var wrap = q('[data-bl-packs]');
    if (!wrap) return;
    var defs = [
      { key: 'basics', name: CFG.packNames.basics, tag: '' },
      { key: 'routine', name: CFG.packNames.routine, tag: CFG.packTags.routine },
      { key: 'all', name: CFG.packNames.all, tag: CFG.packTags.all }
    ];
    wrap.innerHTML = defs.map(function (d) {
      var ps = PACKS[d.key] || [];
      if (!ps.length) return '';
      var pr = packPrice(ps);
      var on = state.pack === d.key;
      var contents = d.key === 'all' ? CFG.allBlurb : ps.map(shortTitle).join(' · ');
      var perks = [];
      if (PROTECT_AT && ps.length >= PROTECT_AT) perks.push('Free package protection');
      if (CREDIT_MIN && ps.length >= CREDIT_MIN) perks.push(CFG.creditLabel);
      if (pr.price >= THRESHOLD) perks.push('Free shipping');
      return '<button type="button" class="bl__pack' + (on ? ' is-on' : '') + (perks.length ? ' bl__pack--wide' : '') +
        '" data-bl-pack="' + d.key + '" role="radio" aria-checked="' + (on ? 'true' : 'false') + '">' +
        (d.tag ? '<span class="bl__pack-tag">' + esc(d.tag) + '</span>' : '') +
        packMedia(ps, d.key) +
        '<span class="bl__pack-b">' +
          '<span class="bl__pack-h"><span class="bl__pack-n">' + esc(d.name) + '</span>' +
          (pr.pct ? '<span class="bl__pack-off">' + pr.pct + '% off</span>' : '') + '</span>' +
          '<span class="bl__pack-c">' + esc(contents) + '</span>' +
          '<span class="bl__pack-p"><span class="bl__pack-v">' + fmt(pr.price) + '</span>' +
          (pr.pct ? '<s class="bl__pack-was">' + fmt(pr.list) + '</s><span class="bl__pack-save">Save ' + fmt(pr.list - pr.price) + '</span>' : '') +
          '</span>' +
        '</span>' +
        '<span class="bl__pack-r" aria-hidden="true">✓</span>' +
        (perks.length ? '<span class="bl__pack-perks">+ ' + esc(perks.join(' · ')) + '</span>' : '') +
        '</button>';
    }).join('');
  }

  /* ---------- render: scents ---------- */
  function renderScents() {
    var chips = q('[data-bl-chips]'), rows = q('[data-bl-rows]'), toggle = q('[data-bl-scents-toggle]');
    var ps = chosen();
    if (chips) {
      chips.innerHTML = ps.map(function (p) {
        var v = variantOf(p), s = shortScent(v.title);
        return '<span class="bl__chip"><i style="background:' + esc(v.color || '#A0A0A0') + '"></i>' +
          esc(chipName(p)) + (s ? ' · ' + esc(s) : '') + '</span>';
      }).join('');
      chips.hidden = state.scentsOpen;
    }
    if (rows) {
      rows.hidden = !state.scentsOpen;
      rows.innerHTML = ps.map(function (p) {
        var vs = inStockVariants(p), cur = variantOf(p);
        var head = '<div class="bl__row-h"><span class="bl__mono">' + esc(p.short || p.title) + '</span></div>';
        if (vs.length < 2) {
          var s1 = shortScent(cur.title);
          return '<div class="bl__row">' + head +
            '<span class="bl__row-one"><i style="background:' + esc(cur.color || '#A0A0A0') + '"></i>' +
            esc(s1 || 'One option') + '</span></div>';
        }
        return '<div class="bl__row">' + head + '<div class="bl__sws">' + (p.variants || []).map(function (v) {
          var on = v.id === cur.id;
          return '<button type="button" class="bl__sw' + (on ? ' is-on' : '') + '" data-bl-sw="' + v.id +
            '" data-bl-sw-p="' + esc(p.handle) + '"' + (v.available ? '' : ' disabled') +
            ' aria-pressed="' + (on ? 'true' : 'false') + '"><i style="background:' + esc(v.color || '#A0A0A0') + '"></i>' +
            '<span>' + esc(shortScent(v.title) || v.title) + (v.available ? '' : ' · out') + '</span></button>';
        }).join('') + '</div></div>';
      }).join('');
    }
    if (toggle) {
      toggle.textContent = state.scentsOpen ? 'Done' : 'Change scents';
      toggle.setAttribute('aria-expanded', state.scentsOpen ? 'true' : 'false');
    }
  }

  /* ---------- render: gifts ---------- */
  function renderGifts(t) {
    var wrap = q('[data-bl-gifts]');
    if (!wrap) return;
    var tiles = [];
    if (PROTECT_AT) tiles.push({ on: t.protect, icon: CFG.icons.shield, label: 'Package protection' });
    tiles.push({ on: t.freeShip, icon: CFG.icons.truck, label: 'Free shipping' });
    if (CREDIT_MIN) tiles.push({ on: t.credit, big: String(CFG.creditLabel || '').split(' ')[0], label: 'Store credit' });
    tiles.push({ on: t.pct > 0, big: (t.pct || 0) + '%', label: 'Off your pack' });
    wrap.innerHTML = tiles.map(function (x) {
      return '<div class="bl__gift ' + (x.on ? 'is-on' : 'is-off') + '">' +
        '<span class="bl__gift-c" aria-hidden="true">✓</span>' +
        (x.big ? '<div class="bl__gift-i"><span class="bl__gift-b">' + esc(x.big) + '</span></div>'
               : '<div class="bl__gift-i">' + (x.icon || '') + '</div>') +
        '<p class="bl__gift-l">' + esc(x.label) + '</p></div>';
    }).join('');
  }

  /* ---------- render: summary, comparison, sticky ---------- */
  function renderSummary(t) {
    var k = q('[data-bl-sum-k]'), price = q('[data-bl-sum-price]'), was = q('[data-bl-sum-was]');
    var nudge = q('[data-bl-nudge]'), addT = q('[data-bl-add-t]');
    if (k) k.textContent = t.n + (t.n === 1 ? ' product' : ' products') + (t.pct ? ' · ' + t.pct + '% off' : '');
    if (price) price.textContent = fmt(t.price);
    if (was) { was.textContent = t.pct ? fmt(t.list) : ''; was.hidden = !t.pct; }
    if (nudge) {
      var nx = nextRung(t.n), bits = [];
      if (t.save > 0) bits.push('You save ' + fmt(t.save));
      if (nx) {
        var need = nx.at - t.n;
        var extra = (CREDIT_MIN && t.n < CREDIT_MIN && nx.at >= CREDIT_MIN) ? ' + ' + CFG.creditLabel : '';
        bits.push('Add ' + need + ' more for ' + nx.pct + '%' + extra);
      } else if (t.allIn) {
        bits.push('All In · ' + t.pct + '% locked in');
      }
      nudge.textContent = bits.join(' · ');
    }
    if (addT) addT.textContent = (state.busy ? 'Adding…' : (root.getAttribute('data-atc') || 'Add my pack') + ' — ' + fmt(t.price));
    qa('[data-bl-add]').forEach(function (b) { b.disabled = state.busy || t.n === 0; });

    var ck = q('[data-bl-cmp-k]'), cus = q('[data-bl-cmp-us]'), tk = q('[data-bl-cmp-them-k]'), them = q('[data-bl-cmp-them]');
    if (ck) ck.textContent = t.n + ' products · ' + t.pct + '% off';
    if (cus) cus.textContent = fmt(t.price);
    if (tk) tk.textContent = t.n + ' products · full price';
    if (them) them.textContent = fmt(t.list);

    var sp = q('[data-bl-sticky-price]'), sw = q('[data-bl-sticky-was]'), sk = q('[data-bl-sticky-k]');
    if (sp) sp.textContent = fmt(t.price);
    if (sw) { sw.textContent = t.pct ? fmt(t.list) : ''; sw.hidden = !t.pct; }
    if (sk) sk.textContent = t.n + ' products · ' + (t.pct || 0) + '% off';
  }

  /* ---------- render: full builder grid ---------- */
  function renderGrid() {
    var grid = q('[data-bl-grid]');
    if (!grid) return;
    grid.hidden = !state.swapOpen;
    if (!state.swapOpen) return;
    grid.innerHTML = AVAIL.map(function (p) {
      var inPack = state.items.indexOf(p.handle) > -1;
      var v = variantOf(p);
      return '<div class="bl__gp' + (inPack ? ' is-in' : '') + '">' +
        '<div class="bl__gp-i"><img src="' + esc(v.image || p.image) + '" alt="" loading="lazy"></div>' +
        '<p class="bl__gp-n">' + esc(p.short || p.title) + '</p>' +
        '<p class="bl__gp-p">' + fmt(v.price) + '</p>' +
        '<button type="button" class="bl__gp-b" data-bl-toggle="' + esc(p.handle) + '">' +
        (inPack ? 'Remove' : 'Add +') + '</button></div>';
    }).join('');
    var sw = q('[data-bl-swap-toggle]');
    if (sw) sw.setAttribute('aria-expanded', 'true');
  }

  function render() {
    var t = totals();
    renderPacks();
    renderHero(t);
    renderScents();
    renderGifts(t);
    renderSummary(t);
    renderGrid();
  }

  /* ---------- add to cart ---------- */
  function track(t) {
    try {
      if (window.fbq) window.fbq('track', 'AddToCart', { value: t.price / 100, currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD', num_items: t.n, content_type: 'product_group' });
      if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: 'byb_lp_add_to_cart', pack: state.pack, products: t.n, discount_pct: t.pct, value: t.price / 100 });
      document.dispatchEvent(new CustomEvent('onside:byb-lp-add', { detail: { pack: state.pack, count: t.n, pct: t.pct, value: t.price } }));
    } catch (e) {}
  }

  function post(items, retry) {
    return fetch(CFG.addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok && !(d && d.status >= 400), d: d }; });
    }).then(function (res) {
      if (res.ok) return true;
      if (retry && items.some(function (i) { return i.selling_plan; })) {
        items.forEach(function (i) { delete i.selling_plan; });
        return post(items, false);
      }
      var isMarker = function (i) { return i.properties && (i.properties._byb_protection || i.properties._byb_credit); };
      if (items.some(isMarker)) return post(items.filter(function (i) { return !isMarker(i); }), false);
      return false;
    }).catch(function () { return false; });
  }

  function addToCart() {
    if (state.busy) return;
    var t = totals();
    if (!t.n) return;
    state.busy = true; render();
    var items = chosen().map(function (p) { return { id: variantOf(p).id, quantity: 1 }; });
    if (CFG.protectionVariant && t.protect) items.push({ id: parseInt(CFG.protectionVariant, 10), quantity: 1, properties: { _byb_protection: 'true' } });
    if (CFG.creditVariant && t.credit) items.push({ id: parseInt(CFG.creditVariant, 10), quantity: 1, properties: { _byb_credit: 'true' } });
    post(items, window.onsideSkioEnabled === true).then(function (ok) {
      state.busy = false; render();
      if (!ok) { window.location.href = CFG.cartUrl; return; }
      track(t);
      if (typeof window.__onsideCartRefresh === 'function') window.__onsideCartRefresh(true);
      else window.location.href = CFG.cartUrl;
    });
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var el;
    if ((el = e.target.closest('[data-bl-pack]'))) { setPack(el.getAttribute('data-bl-pack')); return; }
    if ((el = e.target.closest('[data-bl-thumb]'))) {
      var i = parseInt(el.getAttribute('data-bl-thumb'), 10);
      state.hero = state.hero === i ? 0 : i; render(); return;
    }
    if ((el = e.target.closest('[data-bl-sw]'))) {
      if (el.disabled) return;
      state.sel[el.getAttribute('data-bl-sw-p')] = parseInt(el.getAttribute('data-bl-sw'), 10);
      render(); return;
    }
    if (e.target.closest('[data-bl-scents-toggle]')) { state.scentsOpen = !state.scentsOpen; render(); return; }
    if (e.target.closest('[data-bl-swap-toggle]')) {
      state.swapOpen = !state.swapOpen; render();
      if (state.swapOpen) { var g = q('[data-bl-grid]'); if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      return;
    }
    if ((el = e.target.closest('[data-bl-toggle]'))) {
      var h = el.getAttribute('data-bl-toggle'), at = state.items.indexOf(h);
      if (at > -1) state.items.splice(at, 1);
      else state.items.push(h);
      state.items = AVAIL.map(function (p) { return p.handle; }).filter(function (x) { return state.items.indexOf(x) > -1; });
      var match = ['basics', 'routine', 'all'].filter(function (k) {
        var a = (PACKS[k] || []).map(function (p) { return p.handle; });
        return a.length === state.items.length && a.every(function (x) { return state.items.indexOf(x) > -1; });
      })[0];
      state.pack = match || 'custom';
      state.hero = 0;
      render(); return;
    }
    if ((el = e.target.closest('[data-bl-add]'))) { e.preventDefault(); addToCart(); return; }
    if ((el = e.target.closest('[data-bl-scroll]'))) {
      var target = q(el.getAttribute('data-bl-scroll'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      return;
    }
    if ((el = e.target.closest('[data-bl-play]'))) {
      var v = el.parentNode.querySelector('[data-bl-video]');
      if (v) { v.play(); el.classList.add('is-hidden'); }
      return;
    }
  });

  /* sticky bar from the first scroll past the hero CTA */
  var sticky = q('[data-bl-sticky]');
  if (sticky) {
    var tick = false;
    var sync = function () {
      tick = false;
      var show = window.scrollY > 300;
      if (sticky.hidden === show) sticky.hidden = !show;
    };
    window.addEventListener('scroll', function () { if (!tick) { tick = true; window.requestAnimationFrame(sync); } }, { passive: true });
    sync();
  }

  root.setAttribute('data-atc', (q('[data-bl-add-t]') && q('[data-bl-add-t]').textContent.trim()) || 'Add my pack');
  setPack(AVAIL.length >= (parseInt(CFG.routineCount, 10) || 5) ? 'routine' : 'basics');
})();
